var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsAdd = function SvgIconsAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4c.513 0 .936.386.993.883L13 5v6h6c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L19 13h-6v6c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L11 19v-6H5c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L5 11h6V5c0-.552.448-1 1-1z"
  })));
};
export default SvgIconsAdd;